// extracted by mini-css-extract-plugin
module.exports = {"confirmDialog":"ConfirmDialogPaste_confirmDialog__73Wpg"};